export default (state = {}, { type, payload }) => {
    switch (type) {
        case 'DISABLE_MAP_OBJECTS':
            return {
                disableMapObject: false
            }
        case 'ENABLE_MAP_OBJECTS':
            return {
                disableMapObject: true
            }
        default:
            return state
    }
}